import SelectGame from './SelectGame'
export default SelectGame
